import cookie from 'react-cookies';

import { ACCESS_TOKEN_COOKIE } from '@r1-frontend/shared/constants';

import { isSso } from '~/src/features/user/helpers';
import { TAppThunkDispatch, TGetState } from '~/src/store';
import { logout } from '~/src/store/actions/auth/logout';

export const verifyAuthState = () => {
    return (dispatch: TAppThunkDispatch, getState: TGetState) => {
        const state = getState();
        if (state.auth.isAuth) {
            const accessToken = cookie.load(ACCESS_TOKEN_COOKIE);
            const isAccessTokenDefined = Boolean(accessToken);

            if (!isAccessTokenDefined) {
                if (isSso()) {
                    return window.location.replace(
                        `/user/change-agreement?referrer=${document.location.pathname}`,
                    );
                }

                dispatch(logout());
            }
        }
    };
};
